import { useState } from 'react';

import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material';

// import { usePathname } from 'src/routes/hooks/use-pathname';
import { useActiveLink } from 'src/routes/hooks/use-active-link';

import CustomNavItem from './CustomNavItem';

import type { NavListProps, NavSubListProps } from '../types';

// ----------------------------------------------------------------------

export default function CustomNavList({ data, depth, slotProps }: NavListProps) {
  const activeLink = useActiveLink(data.path, !!data.children);

  const active = slotProps?.scrollNav ? slotProps.activeSection === data.path : activeLink;

  const [isExpanded, setIsExpanded] = useState(true);

  const handleToggleExpand = () => {
    if (data.children) {
      setIsExpanded((prev) => !prev);
    }
  };

  return (
    <Stack spacing={0.5}>
      <CustomNavItem
        id={data.id}
        onClick={handleToggleExpand}
        expanded={isExpanded}
        scrollNav={slotProps?.scrollNav}
        title={data.title}
        path={data.defaultChildPath || data.path}
        icon={data.icon}
        info={data.info}
        roles={data.roles}
        caption={data.caption}
        disabled={data.disabled}
        //
        depth={depth}
        hasChild={!!data.children}
        externalLink={data.path.includes('http')}
        currentRole={slotProps?.currentRole}
        //
        active={active}
        className={active ? 'active' : ''}
        sx={slotProps?.rootItem}
      />

      {!!data.children && isExpanded && (
        <CustomNavSubList data={data.children} depth={depth} slotProps={slotProps} />
      )}
    </Stack>
  );
}

// ----------------------------------------------------------------------

function CustomNavSubList({ data, depth, slotProps }: NavSubListProps) {
  const theme = useTheme();
  return (
    <Stack
      spacing={0.5}
      sx={{
        ml: 1,
        pl: 1,
        borderLeft: `1px dashed ${theme.vars.palette.divider}`,
      }}
    >
      {data.map((list) => (
        <CustomNavList key={list.title} data={list} depth={depth} slotProps={slotProps} />
      ))}
    </Stack>
  );
}
